import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	archiveProject: {
		id: 'navigation-project-action-menu.archive-project.archive-project',
		defaultMessage: 'Archive project',
		description: 'The label for the button that archives a project',
	},
});
